<script setup lang="ts">
defineProps<{
  items: SearchMapItem[]
}>()

const { t: $t } = useI18n()

// Not the cleanest solution, but it works for now
const itemType = inject<'vacancies' | 'organizations'>('mapType', 'vacancies')
</script>

<template>
  <div class="flex flex-col gap-3 p-4">
    <div v-if="items.length > 1" class="flex flex-col">
      <h4 class="text-muted-800 dark:text-muted-100 mb-4 text-lg font-medium leading-none">
        {{ items.length }} {{ itemType == 'vacancies' ? 'vacatures' : 'organisaties' }} gevonden op deze locatie
      </h4>

      <ul class="flex max-h-96 flex-col gap-2 overflow-y-auto">
        <li
          v-for="item in items"
          :key="item.id"
        >
          <NuxtLink
            color="primary"
            class="hover:text-primary-600 dark:hover:text-primary-400 bg-muted-100 dark:bg-muted-800 hover:bg-muted-200 flex items-center gap-2 rounded-md px-3 py-2 transition-colors"
            :to="item.to"
          >
            <BaseAvatar
              v-if="item.avatarUrl"
              :src="item.avatarUrl"
              :alt="item.title"
              class="me-2 size-6"
            />
            <span class="text-size-md">{{ item.title }}</span>
            <Icon name="ph:arrow-right" class="me-1 size-4" />
          </NuxtLink>
        </li>
      </ul>
    </div>
    <div v-else-if="items.length == 1">
      <BaseAvatar
        v-if="items[0].avatarUrl"
        :src="items[0].avatarUrl"
        :alt="items[0].title"
        class="me-2 size-6"
      />

      <h4 class="text-muted-800 dark:text-muted-100 mb-4 text-lg font-medium leading-none">
        {{ items[0].title }}
      </h4>

      <BaseButtonLink
        color="primary"
        :to="items[0].to"
      >
        <span>{{ $t('buttonActions.view') }}</span>
        <Icon name="lucide:arrow-right" class="me-1 size-4" />
      </BaseButtonLink>
    </div>
  </div>
</template>
